import { DraftFormPopupContainer } from '../../Draft'
import { useEmailCreationFormConfirmation, useEmailDraft } from '../Email.hooks'

function EmailCreationPopupContainer({
  title = 'Modal.NewEmailTitleKey',
  onClose,
  onSubmitConfirm,
  ...containerProps
}) {
  const { getLatestDraft, setDraft } = useEmailDraft()

  const { Confirmation, handleSubmitConfirm } =
    useEmailCreationFormConfirmation({ onClose, onSubmitConfirm })

  return (
    <DraftFormPopupContainer
      {...containerProps}
      Confirmation={Confirmation}
      getLatestDraft={getLatestDraft}
      setDraft={setDraft}
      titleKey={title}
      onClose={onClose}
      onSubmitConfirm={handleSubmitConfirm}
    />
  )
}

export default EmailCreationPopupContainer
